import {React,useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent,TextField,Grid, CardMedia, Typography, Button,Menu,MenuItem } from '@mui/material';
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";



const OrganizationForm = ({orgData,saveOrganizations}) => {
OrganizationForm.propTypes = {
  saveOrganizations: PropTypes.func.isRequired,
  orgData: PropTypes.object
};
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    number: '',
    email: '',
    website: '',
  });
  useEffect(() => {
    if (orgData) {
      setFormData({
        id: orgData.id ?? '',
        name: orgData.name ?? '',
        number: orgData.number ?? '',
        email: orgData.email ?? '',
        website: orgData.website ?? '',
      });
    }
    else
    {
      setFormData({
        id: '',
        name: '',
        number: '',
        email: '',
        website: '',
      })
    }
  }, [orgData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const resp =  saveOrganizations(formData);
  }
  const handleClose = () => {
    console.log('Form reset');
  };
   
  return (
    <MDBox
    container
    sx={{
      minHeight: "75vh",
      p: 0,
    }}
  >
    <MDBox
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" component="h1" align="center" gutterBottom>
        Organization Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Organization Name"
              name="name"
              variant="outlined"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </Grid>
          {/* <Grid item xs={12}>
            <TextField
              fullWidth
              label="Address"
              name="address"
              variant="outlined"
              multiline
              rows={3}
              required
              value={formData.address}
              onChange={handleChange}
            />
          </Grid> */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Contact Number"
              name="number"
              variant="outlined"
              type="tel"
              required
              value={formData.number}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              variant="outlined"
              type="email"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Website URL"
              name="website"
              variant="outlined"
              type="url"
              value={formData.website}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="space-between">
            <Button
              type="reset"
              variant="outlined"
              color="secondary"
            //   onClick={handleReset}
            >
              Reset
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </MDBox>
  </MDBox>
  );
};

export default OrganizationForm;
